import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector } from 'react-redux';

import type { AppState } from './redux';

export const useCustomerSelector: TypedUseSelectorHook<AppState> = useSelector;
